var map = {
	"./Attack_Elektricshock.png": "9e8d",
	"./Attack_Goldtornado.png": "7d521",
	"./Attack_hellfire.png": "7432",
	"./Attack_triple dragon.png": "8f78",
	"./Attack_ultimate fire tornado.png": "f8ab",
	"./Attack_ultimategoldendragon.png": "c221",
	"./Attack_utimate ice dragon.png": "3a5d",
	"./Aura_blood.png": "da69",
	"./Aura_darkness.png": "5ad83",
	"./Aura_feather.png": "fc94",
	"./Aura_fire.png": "ab98",
	"./Aura_freeze.png": "96a2",
	"./Aura_glow.png": "474f",
	"./Aura_gold.png": "41ce",
	"./Aura_healing.png": "39ed",
	"./Aura_lightning.png": "96e6",
	"./Aura_magic.png": "5927",
	"./Aura_magicorange.png": "8cc3",
	"./Aura_meteor.png": "ad5e",
	"./Aura_music.png": "29fd",
	"./Aura_mystic.png": "7812",
	"./Aura_shine.png": "c80c",
	"./Aura_shinesparkle.png": "3a06",
	"./Aura_sleep.png": "9201",
	"./Aura_smoke.png": "a5e7",
	"./Aura_soap.png": "e621",
	"./Aura_sparkle.png": "9f15",
	"./Aura_trailcombination.png": "e64b",
	"./Aura_trails.png": "825b",
	"./Aura_water.png": "28e5",
	"./Doom.png": "f712",
	"./Thunder attack.png": "3cf7",
	"./attack-fire_archers.png": "3c5f",
	"./attack_aqua.png": "374b",
	"./attack_bubbleworm.png": "13f3",
	"./attack_burningfield.png": "c39f",
	"./attack_dragonhell.png": "1799",
	"./attack_electricball_blue.png": "e72d",
	"./attack_electricball_red.png": "35b2",
	"./attack_electrictornardo.png": "1c6b",
	"./attack_electrik.png": "aa34",
	"./attack_evil_pillar.png": "e98d",
	"./attack_firedragon.png": "32d9",
	"./attack_fireseed.png": "4289",
	"./attack_god_sword.png": "741d7",
	"./attack_goldencoin.png": "a8ce",
	"./attack_goldendragon.png": "fa62c",
	"./attack_goldenlotus.png": "09d8",
	"./attack_green_ivy.png": "fd65",
	"./attack_health.png": "85ee",
	"./attack_helldoor.png": "e61c",
	"./attack_ice_dragon.png": "2e92",
	"./attack_iceberg.png": "b440",
	"./attack_icepilar.png": "666b",
	"./attack_lava.png": "1fdc",
	"./attack_leafs.png": "e4ec",
	"./attack_matrix.png": "de81",
	"./attack_meteor.png": "3fb2",
	"./attack_pick.png": "b114",
	"./attack_plant.png": "cdcf",
	"./attack_smallDarkmagic.png": "4670",
	"./attack_smalldarkdragon.png": "3998",
	"./attack_special.png": "8c4d",
	"./attack_stormbringer.png": "d7c8",
	"./attack_watertornado.png": "46f6",
	"./attack_whitestorm.png": "3a5d7",
	"./attack_windy.png": "c9ff",
	"./attack_wood.png": "11c9",
	"./aura_hit.png": "7d4b",
	"./healing _all.png": "fb42",
	"./healing_boss.png": "e090"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ff";